import attendeesService from '@/services/attendees'

export default {
  namespaced: true,

  state: {
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '',
    company: '',
    position: '',
    zipCode: '',
    country: '',
    // accessTypesList: [],
    // accessType: '',
    checkPrivacy: false,
    checkAds: false,
    checkPartners: false,
    formSent: false,
  },

  mutations: {
    updateFirstName(state, firstName) {
      state.firstName = firstName
    },

    updateLastName(state, lastName) {
      state.lastName = lastName
    },

    updatePhoneNumber(state, phoneNumber) {
      state.phoneNumber = phoneNumber
    },

    updateEmail(state, email) {
      state.email = email
    },

    updateCompany(state, company) {
      state.company = company
    },

    updatePosition(state, position) {
      state.position = position
    },

    updateZipCode(state, zipCode) {
      state.zipCode = zipCode
    },

    updateCountry(state, country) {
      state.country = country
    },

    // updateAccessTypesList(state, list) {
    //   state.accessTypesList = list
    // },

    // updateAccessType(state, accessType) {
    //   state.accessType = accessType
    // },

    toggleCheckPrivacy(state) {
      state.checkPrivacy = !state.checkPrivacy
    },

    toggleCheckAds(state) {
      state.checkAds = !state.checkAds
    },

    toggleCheckPartners(state) {
      state.checkPartners = !state.checkPartners
    },

    updateCheckPrivacy(state, status) {
      state.checkPrivacy = status
    },

    updateCheckAds(state, status) {
      state.checkAds = status
    },

    updateCheckPartners(state, status) {
      state.checkPartners = status
    },

    updateFormSent(state, status) {
      state.formSent = status
    },
  },

  actions: {
    // fetchAccessTypesList({ commit }) {
    //   attendeesService.getAccessTypesList().then(res => {
    //     commit('updateAccessTypesList', res)
    //   })
    // },

    resetForm({ commit }) {
      commit('updateFirstName', '')
      commit('updateLastName', '')
      commit('updatePhoneNumber', '')
      commit('updateEmail', '')
      commit('updateCompany', '')
      commit('updatePosition', '')
      commit('updateZipCode', '')
      commit('updateCountry', '')
      // commit('updateAccessType', '')
      commit('updateCheckPrivacy', false)
      commit('updateCheckAds', false)
      commit('updateCheckPartners', false)
    },

    createAttendee({ state, commit, dispatch }) {
      const payload = {
        first_name: state.firstName,
        last_name: state.lastName,
        phone_number: state.phoneNumber,
        email: state.email.toLowerCase(),
        company: state.company,
        position: state.position,
        zip_code: state.zipCode,
        country: state.country,
        // access_type: state.accessType,
        privacy: state.checkPrivacy,
        ads: state.checkAds,
        partners: state.checkPartners,
      }

      commit('forms/setSendingData', true, { root: true })
      return new Promise(resolve => {
        attendeesService.createAttendee(payload).then(res => {
          commit('forms/setSendingData', false, { root: true })
          if (res.response) {
            if (res.response.status === 400) {
              commit('forms/setServerErrors', res.response.data, { root: true })
            } else if (res.response.status === 429) {
              commit('auth/setTooManyRequests', true, { root: true })
            }
          } else if (res.first_name) {
            dispatch('resetForm')
            commit('updateFormSent', true)
            resolve()
          }
        })
      })
    },
  },
}
